import Component from '@glimmer/component';
import { action } from '@ember/object';
import { tracked } from '@glimmer/tracking';
import { concat } from '@ember/helper';
import { on } from '@ember/modifier';
import { useStyles } from '@frontile/theme';
import FormField from './form-field.js';
import { precompileTemplate } from '@ember/template-compilation';
import { setComponentTemplate } from '@ember/component';
import { d as decorateFieldV2, i as initializeDeferredDecorator, a as decorateMethodV2 } from '../runtime-BPCpkOf1-DV8zmEr2.js';

class FormInputBase extends Component {
  static {
    decorateFieldV2(this.prototype, "shouldShowErrorFeedback", [tracked], function () {
      return false;
    });
  }
  #shouldShowErrorFeedback = (initializeDeferredDecorator(this, "shouldShowErrorFeedback"), undefined);
  get showErrorFeedback() {
    if (this.args.hasError === false) {
      return false;
    }
    if ((this.args.showError || this.args.hasSubmitted || this.shouldShowErrorFeedback) && this.args.errors && this.args.errors.length > 0) {
      return true;
    } else {
      return false;
    }
  }
  handleFocusIn(event) {
    this.shouldShowErrorFeedback = false;
    if (typeof this.args.onFocusIn === 'function') {
      this.args.onFocusIn(event);
    }
  }
  static {
    decorateMethodV2(this.prototype, "handleFocusIn", [action]);
  }
  handleFocusOut(event) {
    this.shouldShowErrorFeedback = true;
    if (typeof this.args.onFocusOut === 'function') {
      this.args.onFocusOut(event);
    }
  }
  static {
    decorateMethodV2(this.prototype, "handleFocusOut", [action]);
  }
}
class FormInput extends FormInputBase {
  get classes() {
    const {
      formInput
    } = useStyles();
    const {
      base,
      label,
      input,
      hint,
      feedback
    } = formInput({
      size: this.args.size
    });
    return {
      base: base({
        class: this.args.containerClass
      }),
      label: label(),
      input: input({
        class: this.args.inputClass
      }),
      hint: hint(),
      feedback: feedback()
    };
  }
  static {
    setComponentTemplate(precompileTemplate("\n    <FormField @size={{@size}} class={{this.classes.base}} as |f|>\n      {{#if @label}}\n        <f.Label @class={{this.classes.label}}>\n          {{@label}}\n        </f.Label>\n      {{/if}}\n\n      {{#if @hint}}\n        <f.Hint @class={{this.classes.hint}}>\n          {{@hint}}\n        </f.Hint>\n      {{/if}}\n\n      <f.Input {{on \"focus\" this.handleFocusIn}} {{on \"blur\" this.handleFocusOut}} @onInput={{@onInput}} @onChange={{@onChange}} @value={{@value}} @type={{@type}} @class={{this.classes.input}} aria-invalid={{if this.showErrorFeedback \"true\"}} aria-describedby=\"{{if @hint f.hintId}}{{if this.showErrorFeedback (concat \" \" f.feedbackId)}}\" ...attributes />\n\n      {{yield}}\n\n      {{#if this.showErrorFeedback}}\n        <f.Feedback @class={{this.classes.feedback}} @errors={{@errors}} />\n      {{/if}}\n    </FormField>\n  ", {
      strictMode: true,
      scope: () => ({
        FormField,
        concat,
        on
      })
    }), this);
  }
}

export { FormInputBase, FormInput as default };
//# sourceMappingURL=form-input.js.map
